<router-outlet>
    <ngx-loading [show]="loading"></ngx-loading>
</router-outlet>